module.exports = __webpack_public_path__ + "img/IMG_1645_L_Wood_MockedUp.0c0bc4ef.jpg";